import { s as p, x as r, i as s, r as o, e as L } from "../../query-assigned-elements-96a4d233.mjs";
import "../../components/page-footer/index.js";
import "../../index-19a5caf5.mjs";
const f = `:host{--font-regular: "Circular Std Medium", Helvetica, Arial, sans-serif;--font-regular-italic: "Circular Std Medium Italic", Helvetica, Arial, sans-serif;--font-thin: "Circular Std Book", Helvetica, Arial, sans-serif;--font-thin-italic: "Circular Std Book Italic", Helvetica, Arial, sans-serif;--font-bold: "Circular Std Bold", Helvetica, Arial, sans-serif;--font-bold-italic: "Circular Std Bold Italic", Helvetica, Arial, sans-serif;font-size:16px;--fs-xxl: 40px;--fs-xl: 35px;--fs-l: 25px;--fs-m: 19px;--fs-s: 16px;--fs-xs: 14px;--padding-inline: 2em;--padding-block: 2em;--max-width-main-content: 500px;--max-width-menu: 350px;--height-top-menu: 5em;--width-side-menu: 22em;--max-width-search-menu: 550px}@media screen and (max-width: 390px){:host{--fs-xxl: 37px;--fs-xl: 30px;--fs-l: 25px;--fs-m: 18px;--fs-s: 16px;--fs-xs: 14px}}@media screen and (max-width: 1300px){:host{--padding-inline: 1.5em;--padding-block: 1.5em}}@media screen and (max-width: 500px){:host{--padding-inline: 1em;--padding-block: 1.5em}}h1,h2,h3,h4,h5{font-family:var(--font-bold);color:#31273e;margin-block:.5em}h1{font-size:var(--fs-xxl);line-height:1.2}h2{font-size:var(--fs-xl)}h3{font-size:var(--fs-l)}h4{font-size:var(--fs-m)}h5{font-size:var(--fs-s)}p,span,address{font-family:var(--font-thin);font-size:var(--fs-s);color:#919191;line-height:initial;padding:initial;line-height:1.5}a{font-size:1em;color:#00a3ff;text-decoration:underline;cursor:pointer}div{font-family:var(--font-thin);color:#919191;line-height:1}button{display:flex;align-items:center;gap:1.2em;padding:.6em 1.5em;border-radius:1.8em;font-size:1em;cursor:pointer;font-family:var(--font-regular);transition:all .2s ease-in-out;border:none}.gray-box{background-color:#f6f6f6;padding:1.5em;border-radius:.5em;border:1px solid #e0e0e0;text-align:center}.page-container{display:flex;flex-direction:column;height:100%;min-height:100svh;overflow-x:hidden;overflow-y:auto;margin:0;padding:0}.page-container .page-content{display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;gap:3em;font-size:.9em;justify-self:center;align-self:center;flex:1;padding:var(--padding-block) var(--padding-inline)}.page-container .page-content h2{margin:0;text-align:center}.page-container .page-massage{color:#919191;background-color:#f5f5f5;max-width:var(--max-width-main-content);border-radius:1em;padding:1em var(--padding-inline);height:max-content}.page-container .page-massage>*{text-align:center}@media screen and (max-width: 500px){.page-container .page-massage{border-radius:0;max-width:initial;margin-inline:calc(var(--padding-inline) * -1)}}.page-container .page-illustration{width:100%;max-width:var(--max-width-main-content)}.page-container .page-illustration svg{width:100%;max-height:350px}@keyframes cut{0%{transform:translate(2%)}to{transform:translate(-6%)}}svg #saw{animation:cut .7s ease-in-out infinite alternate}
`;
var h = Object.defineProperty, c = Object.getOwnPropertyDescriptor, g = (n, i, t, a) => {
  for (var C = a > 1 ? void 0 : a ? c(i, t) : i, e = n.length - 1, l; e >= 0; e--)
    (l = n[e]) && (C = (a ? l(i, t, C) : l(C)) || C);
  return a && C && h(i, t, C), C;
};
let d = class extends p {
  constructor() {
    super(...arguments), this.illustrationSVG = r`
      <svg viewBox="0 0 367 190" fill="none" xmlns="http://www.w3.org/2000/svg">
         <g id="saw">
            <path
               d="M86.7 81.8001V79.0001C86.7 78.1001 87.1 76.9001 87.4 76.2001L87.2 75.5001L65 75.4001L47 70.6001V86.7001L67.4 87.9001L87.3 85.6001L87.6 84.9001C87.2 84.1001 86.7 82.7001 86.7 81.8001Z"
               fill="#85AA13"
            />
            <path
               d="M87.1999 75.5C87.1999 75.5 86.0999 80 87.1999 85.5C87.3999 85.2 89.6999 81.6 87.1999 75.5Z"
               fill="#273A4D"
            />
            <path
               d="M100.5 81.8001C100.5 85.0001 97.9 87.7001 94.6 87.7001H92.6C89.4 87.7001 86.7 85.1001 86.7 81.8001V79.0001C86.7 75.8001 89.3 73.1001 92.6 73.1001H94.6C97.8 73.1001 100.5 75.7001 100.5 79.0001V81.8001Z"
               fill="#FFCC99"
            />
            <path
               d="M94.9 87.7998V110.3L98.1 113.3L100.9 110.3L103.9 113.3L106.7 110.4L109.6 113.3L112.4 110.3L115.4 113.3L118.2 110.4L121 113.3L123.9 110.3L126.8 113.3L129.6 110.4L132.5 113.3L135.4 110.3L138.3 113.3L141 110.5L143.8 113.3L146.6 110.3L149.6 113.3L152.4 110.4L155.3 113.3L158.1 110.3L161.1 113.3L163.8 110.4L166.7 113.3L169.6 110.3L172.5 113.3L175.3 110.4L178.2 113.3L181.1 110.3L184 113.3L186.6 110.6L189.2 113.3L192.1 110.3L195 113.3L197.8 110.4L200.7 113.3L203.6 110.3L206.5 113.3L209.3 110.4L212.1 113.3L215 110.3L217.9 113.3L220.8 110.4L223.6 113.3L226.5 110.3L229.4 113.3L232.1 110.5L234.9 113.3L237.7 110.3H237.8L240.7 113.3L243.5 110.4L246.4 113.3L249.2 110.3H249.3L252.2 113.3L255 110.4L257.8 113.3L260.7 110.3L263.6 113.3L266.4 110.4L269.3 113.3L272.2 110.3L275.1 113.3L278 110.3L278.2 87.7998H94.9Z"
               fill="#C2C2C2"
            />
            <path
               d="M286 81.3V78.5C286 77.6 285.6 76.4 285.3 75.7L285.5 75L307.7 74.9L329 74.2L328.3 86.7L305.4 87.4L285.5 85.1L285.2 84.4C285.5 83.6 286 82.2 286 81.3Z"
               fill="#0079AF"
            />
            <path
               d="M285.5 75C285.5 75 286.6 79.5 285.5 85C285.3 84.7 283 81.1 285.5 75Z"
               fill="#273A4D"
            />
            <path
               d="M272.2 81.3001C272.2 84.5001 274.8 87.2001 278.1 87.2001H280.1C283.3 87.2001 286 84.6001 286 81.3001V78.5001C286 75.3001 283.4 72.6001 280.1 72.6001H278.1C274.9 72.6001 272.2 75.2001 272.2 78.5001V81.3001Z"
               fill="#FFCC99"
            />
            <path
               d="M276.7 109C276.7 110.3 277.8 111.4 279.1 111.4C280.4 111.4 281.5 110.3 281.5 109V72.4C281.5 71.1 280.4 70 279.1 70C277.8 70 276.7 71.1 276.7 72.4V109Z"
               fill="#996633"
            />
            <path
               d="M278.9 74L281.5 75.1V78.7C281.3 78.9 281.1 79.2 281.1 80.1C281.1 81.6 281 88.9 276.7 87.7V74.7L278.9 74Z"
               fill="#734D26"
            />
            <path
               d="M272.9 81.3C272.9 84.2 274.3 86.6 276 86.6H277.1C278.8 86.6 280.2 84.2 280.2 81.3V78.8C280.2 75.9 278.8 73.5 277.1 73.5H276C274.3 73.5 272.9 75.9 272.9 78.8V81.3Z"
               fill="#FFCC99"
            />
            <path
               d="M279.9 76.6C279.9 76.6 274.3 76.2 275.4 73.2C275.9 73 276.4 72.8 276.5 72.8C276.6 72.8 279.6 75.1 279.9 76.6Z"
               fill="#BF9973"
            />
            <path
               d="M283.7 75.7001C283.3 76.7001 282.2 77.1001 281.2 76.7001L277.3 75.1001C276.3 74.7001 275.9 73.6001 276.3 72.6001C276.7 71.6001 277.8 71.2001 278.8 71.6001L282.7 73.2001C283.6 73.7001 284.1 74.8001 283.7 75.7001Z"
               fill="#FFCC99"
            />
            <path
               d="M95.9 109.4C95.9 110.7 94.8 111.8 93.5 111.8C92.2 111.8 91.1 110.7 91.1 109.4V72.9C91.1 71.6 92.2 70.5 93.5 70.5C94.8 70.5 95.9 71.6 95.9 72.9V109.4Z"
               fill="#996633"
            />
            <path
               d="M93.8 74.5L91.2 75.6V79.2C91.4 79.4 91.6 79.7 91.6 80.6C91.6 82.1 91.7 89.4 96 88.2V75.2L93.8 74.5Z"
               fill="#734D26"
            />
            <path
               d="M99.8 81.8C99.8 84.7 98.4 87.1 96.7 87.1H95.6C93.9 87.1 92.5 84.7 92.5 81.8V79.3C92.5 76.4 93.9 74 95.6 74H96.7C98.4 74 99.8 76.4 99.8 79.3V81.8Z"
               fill="#FFCC99"
            />
            <path
               d="M92.7999 77.0998C92.7999 77.0998 98.3999 76.6998 97.2999 73.6998C96.7999 73.4998 96.2999 73.2998 96.1999 73.2998C96.0999 73.2998 92.9999 75.5998 92.7999 77.0998Z"
               fill="#BF9973"
            />
            <path
               d="M89 76.2001C89.4 77.2001 90.5 77.6001 91.5 77.2001L95.4 75.6001C96.4 75.2001 96.8 74.1001 96.4 73.1001C96 72.1001 94.9 71.7001 93.9 72.1001L90 73.7001C89 74.2001 88.6 75.3001 89 76.2001Z"
               fill="#FFCC99"
            />
         </g>
         <path
            opacity="0.4"
            d="M184 189.1C197.034 189.1 207.6 184.22 207.6 178.2C207.6 172.18 197.034 167.3 184 167.3C170.966 167.3 160.4 172.18 160.4 178.2C160.4 184.22 170.966 189.1 184 189.1Z"
            fill="#B4B4B4"
         />
         <path
            d="M199.1 177.7L189.8 171.7L199.1 165.7C200.7 164.7 201.1 162.6 200.1 161C199.1 159.4 197 159 195.4 160L183.6 167.7L172.4 160.5C170.8 159.5 168.7 159.9 167.7 161.5C166.7 163.1 167.1 165.2 168.7 166.2L177.3 171.8L168.7 177.4C167.1 178.4 166.7 180.5 167.7 182.1C168.7 183.7 170.8 184.1 172.4 183.1L183.6 175.9L195.4 183.6C197 184.6 199.1 184.2 200.1 182.6C201.1 180.8 200.7 178.7 199.1 177.7Z"
            fill="#3C3C3C"
         />
         <path
            opacity="0.4"
            d="M34.1 178.2C51.3866 178.2 65.4001 175.066 65.4001 171.2C65.4001 167.334 51.3866 164.2 34.1 164.2C16.8135 164.2 2.80005 167.334 2.80005 171.2C2.80005 175.066 16.8135 178.2 34.1 178.2Z"
            fill="#B4B4B4"
         />
         <path
            opacity="0.4"
            d="M332.6 181.7C351.378 181.7 366.6 178.297 366.6 174.1C366.6 169.903 351.378 166.5 332.6 166.5C313.822 166.5 298.6 169.903 298.6 174.1C298.6 178.297 313.822 181.7 332.6 181.7Z"
            fill="#B4B4B4"
         />
         <path
            d="M57.4001 109.5L55.1001 167.7L40.6001 169.8C40.6001 169.8 36.9001 137.6 34.3001 128.6C31.8001 151.8 25.4001 170.6 25.4001 170.6H11.6001C11.6001 170.6 11.8001 153 12.3001 144.2C12.8001 135.4 7.70007 111.9 7.70007 111.9L57.4001 109.5Z"
            fill="#2A2644"
         />
         <path
            d="M7.60008 112C14.7001 114.6 17.9001 115.4 32.5001 114.5C32.5001 114.5 48.7001 113.6 57.4001 109.5L58.3001 73.8001C57.4001 59.2001 44.8001 48.1001 30.2001 49.0001C15.6001 49.9001 4.50008 62.5001 5.40008 77.1001L7.60008 112Z"
            fill="#90C019"
         />
         <path
            d="M46.6001 53.5001C46.6001 53.5001 36.6001 65.8001 19.2001 52.1001C26.9001 49.9001 43.7001 51.7001 43.7001 51.7001C43.7001 51.7001 45.1001 52.3001 46.6001 53.5001Z"
            fill="#6B8713"
         />
         <path
            d="M41.3981 53.2284C52.9618 47.7085 57.8613 33.8595 52.3415 22.2958C46.8217 10.7321 32.9727 5.83252 21.4089 11.3524C9.84521 16.8722 4.94566 30.7212 10.4655 42.2849C15.9853 53.8487 29.8343 58.7482 41.3981 53.2284Z"
            fill="#FFCC99"
         />
         <path
            opacity="0.36"
            d="M53.9 28.2C54.6 31 54.8 33.6 54.1 36.7C53.7 36.8 22.5 41.1999 8.20004 36.0999C7.50004 33.7999 8.00004 35.6999 8.10004 33.2999L19.5 31.4L53.9 28.2Z"
            fill="#604D3A"
         />
         <path
            d="M1.80004 30.6L5.00004 30.4C5.00004 16.2 16.1 4.30001 30.4 3.60001C44.7 3.00001 57 13.8 58.3 27.9L61.5 27.7C62.5 27.6 63.4 29.1 63.5 30.9C63.6 32.7 62.8 34.2 61.8 34.3L2.20004 37.2C1.20004 37.3 0.300042 35.8 0.200042 34C4.17382e-05 32.2 0.80004 30.7 1.80004 30.6Z"
            fill="#FFCC00"
         />
         <path
            opacity="0.39"
            d="M54.2001 61.1998C56.5001 64.7998 58.0001 69.0998 58.3001 73.6998L57.4001 109.4C48.7001 113.4 32.5001 114.4 32.5001 114.4C31.9001 114.4 31.4001 114.5 30.8001 114.5C15.4001 57.6999 54.1001 61.1998 54.2001 61.1998Z"
            fill="#41997C"
         />
         <path
            d="M57.6 99.7L27.7 106.9C24.9 107 21.3 105.3 20.3 102.7L19.3 99.8C19.2 99.5 12.8 76.3 12.8 76.3C11.9 72.8 11.8 69.9 18.6 69C22.2 68.5 26.4 71.7 27.3 75.2L31.2 93.4L57.7 94.2C57.8 96.8 57.8 96.4 57.6 99.7Z"
            fill="#819B13"
         />
         <path
            d="M68.6001 88.5C67.8001 85.5 65.9001 83.2 62.9001 84L58.6001 85.2L60.6001 84.7C60.6001 84.7 53.5001 81.4 54.4001 88.8L47.6001 90.6L49.3001 97.1L56.0001 95.3C57.4001 96.4 59.3001 96.9 61.1001 96.4L66.0001 95C69.0001 94.2 69.5001 91.5 68.6001 88.5Z"
            fill="#FFCC99"
         />
         <path
            d="M54.6 97.7999L28.3 103.3C25.5 103.4 21.9 101.7 20.9 99.0999L19.9 96.1999C19.8 95.8999 12.8 76.2999 12.8 76.2999C11.9 72.7999 12.4 66.2999 19.2 65.3999C22.8 64.8999 27 68.0999 27.9 71.5999L31.8 89.7999L51.6 88.4999C53.7 90.4999 55.2 94.5999 54.6 97.7999Z"
            fill="#90C019"
         />
         <path
            d="M35.6001 44.1999C35.8001 44.0999 36.0001 43.9999 36.2001 43.9999C36.5001 43.8999 36.8001 43.8999 37.1001 43.8999L41.0001 44.1999H41.1001C42.3001 43.8999 43.5001 44.4999 44.1001 45.5999C44.7001 46.8999 44.2001 48.3999 42.9001 49.0999C41.6001 49.6999 40.1001 49.1999 39.4001 47.8999C39.3001 47.7999 39.3001 47.5999 39.3001 47.4999C39.1001 48.1999 38.6001 48.6999 37.9001 48.9999C36.6001 49.5999 35.0001 49.0999 34.4001 47.7999C33.8001 46.3999 34.3001 44.8999 35.6001 44.1999Z"
            fill="#FFCC99"
         />
         <path
            d="M32.2 48L53.4 47.0999C53.4 47.0999 52.1 41 45.3 40.2C38.4 39.3 31.8 43.6 32.2 48Z"
            fill="#515A65"
         />
         <path
            d="M45.9001 43C45.9001 43 42.1001 46.3 39.8001 42.5C37.5001 38.7 39.5001 36.7 39.5001 36.7L46.4001 36.9C46.3001 36.9 48.0001 39.9 45.9001 43Z"
            fill="#FFCC99"
         />
         <path
            d="M160.6 101.4L151.2 124.3H216.6C216.6 124.3 212.4 112.1 208.5 102.4C186.6 80.7 160.6 101.4 160.6 101.4Z"
            fill="#734D4D"
         />
         <path
            d="M184 167.7C202.778 167.7 218 152.478 218 133.7C218 114.922 202.778 99.7 184 99.7C165.222 99.7 150 114.922 150 133.7C150 152.478 165.222 167.7 184 167.7Z"
            fill="#996633"
         />
         <path
            d="M184 164.1C200.789 164.1 214.4 150.49 214.4 133.7C214.4 116.911 200.789 103.3 184 103.3C167.211 103.3 153.6 116.911 153.6 133.7C153.6 150.49 167.211 164.1 184 164.1Z"
            fill="#CC9900"
         />
         <path
            opacity="0.4"
            d="M205.5 122C204.7 119.1 202.6 116.8 200.2 115.1C197.8 113.4 195 112.3 192.2 111.5C189.3 110.8 186.4 110.4 183.5 110.5C180.6 110.7 177.7 111.4 175 112.6C169.6 114.9 164.9 118.9 162.2 124C160.8 126.5 160.3 129.4 160.6 132.2C160.9 135 162 137.8 163.4 140.3C164.8 142.8 166.4 145.3 168.4 147.4C170.3 149.5 172.7 151.2 175.3 152.5C177.8 153.8 180.7 154.6 183.5 154.8C186.3 155 189.2 154.5 191.8 153.4C194.4 152.3 196.7 150.6 198.6 148.4C199.5 147.3 200.3 146.2 201 144.9C201.7 143.7 202.3 142.3 202.7 141C203.6 138.3 203.8 135.4 203.2 132.7C202.7 129.9 201.4 127.3 199.7 125.1C198.8 124 197.9 122.8 196.9 122C195.8 121.2 194.6 120.6 193.3 120.2C190.6 119.5 187.7 119.6 184.9 120.1C182.1 120.6 179.3 121.5 176.7 122.7C175.4 123.3 174.1 124 172.9 124.8C171.8 125.6 170.7 126.6 170 127.7C168.4 129.9 167.9 132.8 168.5 135.5C169.1 138.2 170.8 140.6 173 142.4C175.2 144.2 177.8 145.5 180.6 146C183.4 146.6 186.3 146.4 188.9 145.3C191.5 144.2 193.6 142.2 195 139.7C195.7 138.5 196 137.2 196 135.8C196 134.4 195.5 133.1 194.9 131.8C193.5 129.3 191.3 127.3 188.6 126.3C187.3 125.8 185.9 125.5 184.5 125.6C183.1 125.7 181.8 126.2 180.6 127C179.4 127.8 178.2 128.7 177.4 129.8C176.6 130.9 176.2 132.3 176.6 133.7C176.9 135.1 177.6 136.4 178.6 137.4C179.6 138.4 181 139.1 182.4 139.4C183.8 139.7 185.3 139.6 186.7 139.1C187.4 138.8 188 138.5 188.4 137.9C188.8 137.3 188.9 136.6 188.7 135.9C188.6 135.2 188.2 134.6 187.6 134.1C187 133.6 186.4 133.3 185.7 133C185 132.7 184.3 132.5 183.6 132.5C182.9 132.5 182.1 132.5 181.5 133.1C182 132.6 182.9 132.4 183.6 132.5C184.3 132.5 185.1 132.7 185.8 132.9C186.5 133.2 187.2 133.5 187.8 133.9C188.4 134.3 188.9 135 189.1 135.8C189.3 136.5 189.2 137.4 188.8 138.1C188.4 138.8 187.7 139.2 187 139.5C185.6 140.1 184 140.2 182.5 139.9C181 139.6 179.6 138.9 178.4 137.9C177.2 136.9 176.4 135.4 176.1 133.9C175.9 133.1 175.9 132.3 176 131.5C176.2 130.7 176.5 130 176.9 129.3C177.8 128 179 127 180.3 126.2C181.5 125.3 183.1 124.6 184.6 124.5C186.2 124.4 187.8 124.6 189.2 125.2C192.1 126.3 194.6 128.4 196.2 131.1C197 132.5 197.5 134 197.6 135.6C197.7 137.2 197.3 138.9 196.5 140.2C195 142.9 192.7 145.3 189.8 146.5C186.9 147.8 183.6 148 180.6 147.4C177.5 146.8 174.7 145.4 172.2 143.5C169.8 141.5 167.8 138.8 167.1 135.7C166.3 132.6 166.9 129.1 168.8 126.5C169.7 125.2 170.9 124 172.2 123.1C173.5 122.2 174.8 121.5 176.2 120.8C179 119.5 181.9 118.5 184.9 118C187.9 117.5 191.1 117.3 194.2 118.1C195.7 118.5 197.2 119.2 198.5 120.2C199.2 120.7 199.7 121.3 200.2 121.9C200.7 122.5 201.2 123.1 201.7 123.7C203.6 126.2 205 129.1 205.6 132.2C206.2 135.3 205.9 138.5 205 141.5C204.5 143 203.9 144.4 203.1 145.8C202.4 147.1 201.5 148.4 200.5 149.6C198.5 152 195.9 153.9 193 155.1C190.1 156.3 187 156.8 183.9 156.6C180.8 156.4 177.8 155.5 175 154.1C173.6 153.4 172.3 152.6 171.1 151.7C169.9 150.8 168.7 149.7 167.7 148.6C165.6 146.3 164 143.7 162.6 141.1C161.2 138.4 160.1 135.5 159.8 132.4C159.5 129.3 160.2 126.1 161.7 123.4C164.7 118 169.6 114 175.2 111.7C178 110.6 181 109.9 184 109.7C187 109.6 190 110.1 192.9 110.9C195.8 111.7 198.6 113 201 114.8C202.7 116.7 204.7 119.1 205.5 122Z"
            fill="#94765A"
         />
         <path
            d="M305.4 113.1V165.3L323 169C323 169 321.2 122.8 331 124.7C340.8 126.7 344.4 170.4 344.4 170.4L359.9 169.4L354.4 104.5L305.4 113.1Z"
            fill="#5C5C85"
         />
         <path
            opacity="0.46"
            d="M323 169.1C323 169.1 321.2 122.9 331 124.8C331.8 125 332.6 125.4 333.3 126.1C333.3 126.1 321.1 114.7 305.4 113.1V165.3L323 169.1Z"
            fill="#333366"
         />
         <path
            d="M354.6 104.7C348.3 108.8 345.3 110.3 330.8 112.5C330.8 112.5 314.8 115.1 305.4 113.1L296.8 78.3999C294.5 63.8999 304.4 50.3999 318.9 48.0999C333.4 45.7999 346.9 55.6999 349.2 70.1999L354.6 104.7Z"
            fill="#00A5F3"
         />
         <path
            d="M303.7 56.1C303.7 56.1 316.1 65.9 330.1 48.8C322.1 48.4 306.1 53.8 306.1 53.8C306.1 53.8 305 54.6 303.7 56.1Z"
            fill="#3A5673"
         />
         <path
            d="M336.572 37.2775C339.443 24.7899 331.648 12.339 319.16 9.46765C306.673 6.59625 294.222 14.3917 291.351 26.8793C288.479 39.3668 296.275 51.8177 308.762 54.6891C321.25 57.5605 333.701 49.7651 336.572 37.2775Z"
            fill="#FFCC99"
         />
         <path
            d="M322.3 41.7999C313.6 36.5999 296.2 46.4999 295.9 46.6999C299.1 50.5999 303.4 53.5999 308.7 54.7999C314 55.9999 321.5 55.6999 328.5 50.1999C328.7 49.9999 327.6 44.9999 322.3 41.7999Z"
            fill="#798797"
         />
         <path
            d="M303.2 43.4998C303.2 43.4998 307.6 45.8998 309 41.5998C310.4 37.3998 308.1 35.7998 308.1 35.7998L301.4 37.4998C301.4 37.5998 300.5 40.9998 303.2 43.4998Z"
            fill="#FFCC99"
         />
         <path
            opacity="0.3"
            d="M290.8 31.5999C290.7 34.4999 291.2 37.4 292.2 40C292.6 40 324.2 37.5 337.1 29.4C337.3 27 337.2 28.9 336.6 26.7L325 27.4L290.8 31.5999Z"
            fill="#604D3A"
         />
         <path
            d="M341.5 21.3999L338.4 21.8999C335.3 7.99989 321.9 -1.10011 307.8 1.29989C293.7 3.69989 284.1 16.8999 285.8 30.9999L282.7 31.4999C281.7 31.6999 281.1 33.2999 281.4 35.0999C281.7 36.8999 282.8 38.1999 283.8 37.9999L342.6 27.8999C343.6 27.6999 344.2 26.0999 343.9 24.2999C343.6 22.4999 342.5 21.1999 341.5 21.3999Z"
            fill="#FFCC00"
         />
         <path
            d="M301.5 95.3998L294.6 96.4998C290.7 88.2998 287.2 95.1998 287.2 95.1998L284.8 95.5998C281.7 96.0998 280.9 98.8998 281.4 102C281.9 105.1 283.3 107.4 286.5 106.9L291.4 106.2C293.3 105.9 294.9 104.7 295.7 103.1L302.6 102L301.5 95.3998Z"
            fill="#FFCC99"
         />
         <path
            d="M298 65.3C296.5 69.4 296 73.8 296.8 78.4L305.4 113.1C314.8 115.2 330.8 112.5 330.8 112.5C331.4 112.4 331.9 112.3 332.4 112.2C335.1 53.4 298.1 65.3 298 65.3Z"
            fill="#0088E3"
         />
         <path
            d="M304.4 109L321 106.6C324.1 106.1 326.4 105.3 327.5 102.8C327.6 102.5 327.7 102.3 327.8 102L338.8 72.3998C339.8 68.8998 342.5 59.4998 334.6 58.4998C331 57.9998 325.6 63.9998 324.6 67.3998L316.6 94.0998L301.8 96.9998C302.1 99.8998 303.6 105.8 304.4 109Z"
            fill="#0066AA"
         />
         <path
            d="M295.6 105.9L320.8 102.2C324.2 101.6 326.2 100.9 327.3 98.3999C327.4 98.0999 327.5 97.8999 327.6 97.5999L339.3 68.3C340.3 64.8 340.1 58.2999 333.3 57.1999C329.7 56.5999 325.4 59.5999 324.3 63.0999L318.1 88.4999L293.6 93.0999C294.1 95.9999 295.1 102.8 295.6 105.9Z"
            fill="#00B5F4"
         />
         <path
            d="M312.4 44.6999C312.2 44.6999 312 44.5999 311.8 44.5999C311.5 44.5999 311.2 44.5999 310.9 44.6999L307.2 45.7999H307.1C305.9 45.7999 304.8 46.5999 304.5 47.7999C304.2 49.1999 305.1 50.5999 306.5 50.8999C307.9 51.1999 309.3 50.3999 309.6 48.9999C309.6 48.8999 309.6 48.6999 309.7 48.5999C310.1 49.1999 310.6 49.5999 311.4 49.7999C312.8 50.0999 314.2 49.1999 314.6 47.7999C314.7 46.3999 313.8 44.9999 312.4 44.6999Z"
            fill="#FFCC99"
         />
         <path
            d="M37.6 168.4C37.6 172.3 42 172.1 48.8 172.1C55.6 172.1 61.1 172.3 61.1 168.4C61.1 164.5 55.6 162.2 48.8 162.2C42 162.2 37.6 164.6 37.6 168.4Z"
            fill="#1A1A33"
         />
         <path
            d="M300.4 170.9C300.4 174.8 304.8 174.6 311.6 174.6C318.4 174.6 323.9 174.8 323.9 170.9C323.9 167 318.4 164.7 311.6 164.7C304.8 164.6 300.4 167 300.4 170.9Z"
            fill="#996666"
         />
         <path
            d="M9.09998 170.5C9.09998 174.4 13.5 174.2 20.3 174.2C27.1 174.2 32.6 174.4 32.6 170.5C32.6 166.6 27.1 164.3 20.3 164.3C13.5 164.2 9.09998 166.6 9.09998 170.5Z"
            fill="#1A1A33"
         />
         <path
            d="M341.6 172.5C341.6 176.4 346 176.2 352.8 176.2C359.6 176.2 365.1 176.4 365.1 172.5C365.1 168.6 359.6 166.3 352.8 166.3C346 166.3 341.6 168.6 341.6 172.5Z"
            fill="#996666"
         />
      </svg>
   `;
  }
  render() {
    return r`
         <div class="page-container">
            <div class="page-content">
               <div class="page-illustration">${this.illustrationSVG}</div>
               <h2 id="title">Currently Undergoing Maintenance</h2>
               <span class="page-massage">
                  <p>We're working hard to restore service as quickly as possible.</p>
                  <p>
                     If you have any concerns, please visit our
                     <a href="https://support.rentpost.com">support portal</a> for
                     assistance.
                  </p>
               </span>
            </div>
            <page-footer></page-footer>
         </div>
      `;
  }
  static get styles() {
    return s`
         ${o(f)}
      `;
  }
};
d = g([
  L("page-error-maintenance")
], d);
export {
  d as PageErrorMaintenanceElement
};
//# sourceMappingURL=index.js.map
